import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnBuyStep_13 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnBuyStep_13 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_13) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_12);
    onReset(["timeIntervalTypeView"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_14);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="view"
        text="Желаемое время просмотра:"
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_13;
